export const mockClient = {
  id: 'clientId',
  name: 'Contact person',
  email: 'person@company.com',
  phoneNumber: '+40 720 123 465',
  companyName: 'Company Limited',
  companyVatId: 'CO-123456',
};
